module.exports = __webpack_public_path__ + "static/media/tapHouse.90d9675c.jpg";